import { render, staticRenderFns } from "./ListarEmbalagem.vue?vue&type=template&id=67175810"
import script from "./ListarEmbalagem.vue?vue&type=script&lang=js"
export * from "./ListarEmbalagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports